import Config from "../../../../../shared/src/ranj/app/config/Config";
import AppModel from "../../../../../shared/src/ranj/app/core/AppModel";
import PlayMode from "../../../../../shared/src/ranj/equalture/model/PlayMode";

export default class GameConfig extends Config {
    /**
     * @constructor
     * @param {AppModel} appModel 
     */
    constructor(appModel) {
        super();

        this._appModel = appModel;
    }

    get puzzles() {
        return this.getValue(`puzzles`);
    }
    
    get practicePuzzles() {
        return this.getValue(`practicePuzzles`);
    }

    getPracticePuzzle(idx, wrap = true) {
        if (wrap) {
            idx = idx % this.practicePuzzles.length
        }
        return this.practicePuzzles[idx];
    }

    getPuzzle(idx, wrap = true) {
        if (wrap) {
            idx = idx % this.puzzles.length
        }
        return this.puzzles[idx];
    }

    get time() {
        const timeConfigurations = this.getValue(`time`);
        const playMode = this._appModel.playMode;
        if (!timeConfigurations.hasOwnProperty(playMode)) {
            console.warn(`Tried getting time for play_mode '${playMode}', but no time for this play_mode was defined in game.json. Falling back to assessment time.`);
            return timeConfigurations[PlayMode.ASSESSMENT];
        }

        return timeConfigurations[playMode];
    }

    getLocation(index) {
        return this.getValue(`locations`)[index];
    }

    getLocationSkin(index) {
        return this.getLocation(index).skin;
    }

    getItemName(index) {
        return this.getValue(`items`)[index];
    }

}